<template>
  <div v-if="child">
    <div class="header"
         :class="headerStyles">
      <div class="back">
        <router-link :to="profileRoute"
                     class="back-link one-liner">
          <icon-arrow-left width="20"
                           height="20"
                           icon-color="#7c65b5" />
          {{ $t("schedule.backToProfile", { name: child.name }) }}
        </router-link>
      </div>
      <div class="title">
        {{ $t("schedule.profile", { name: child.name }) }}
      </div>
      <div class="indicator"></div>
    </div>

    <Schedule ref="schedule"
              :child-id="id" />

    <portal to="modals">
      <schedule-alert-modal @save="save"
                            @discard="discard" />
    </portal>
  </div>
</template>

<script>
  import Schedule from '@/components/Schedule/Schedule.vue'
  import IconArrowLeft from "../../components/Icons/IconArrowLeft";
  import ScheduleAlertModal from '@/components/Modals/ScheduleAlertModal'

  export default {
    props: {
      id: {
        required: true
      }
    },

    components: {
      ScheduleAlertModal,
      IconArrowLeft,
      Schedule
    },

    data() {
      return {
        child: null,
        next: null
      }
    },

    created() {
      this.child = this.getChildById(this.id)
    },

    computed: {
      profileRoute() {
        return {
          name: 'children.single',
          params: {
            id: this.id
          }
        }
      },

      ...mapGetters('children', {
        getChildById: 'getById'
      }),

      headerStyles() {
        return {
          'header-mobile': this.$mq === 'mobile'
        }
      }
    },

    methods: {
      save() {
        this.$refs.schedule.updateSchedule()
        this.next()
      },

      discard() {
        this.next()
      }
    },

    beforeRouteLeave(to, from, next) {
      if(this.$refs.schedule.scheduleChanged) {
        this.showModal('scheduleAlert')
        this.next = next

        return
      }

      next()
    }
  }
</script>

<style lang="scss" scoped>
  .schedule {
    position: relative;
    height: 100%;
    padding: 10px;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);

    .back {
      display: flex;
      align-items: center;

      .back-link {
        width: 300px;
        color: map.get($colors, primary);
        font-size: 20px;
        margin-left: 6px;

        display: inline-block;
      }
    }

    .title {
      font-size: 20px;
      font-weight: bold;
      color: map.get($colors, primary);
    }

    .indicator {
      flex: 0 0 100px;
    }
  }

  .header-mobile {
    padding: 15px;

    .title {
      display: none;
    }

    .indicator {
      display: none;
    }
  }
</style>
